/* Umriss füllt sich „Dezent“ (28.10.2026) – [data-dzo] in sections/sushi-dz-outline. Schriftgröße passt sich der Breite an
   (Desktop „row“: alle Wörter in eine Zeile, bis zur maximalen Größe; untereinander: längstes Wort = volle Breite).
   Die Füllung folgt dem Scrollen: in der Zeile nacheinander von links, untereinander jede Zeile für sich.
   Bei „Bewegung reduzieren“ sind die Wörter sofort gefüllt. */
(() => {
  if (window.__sushiDzo) return;
  window.__sushiDzo = true;
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mob = matchMedia('(max-width: 749px)');
  const secs = [], seen = new WeakSet();
  const clamp = (v) => Math.min(1, Math.max(0, v));
  const stacked = (sec) => mob.matches || sec.classList.contains('dzo--stack');
  const fit = (sec) => {
    const row = sec.querySelector('.dzo-row'), ws = [...sec.querySelectorAll('.dzo-w')];
    if (!row || !ws.length) return;
    row.style.setProperty('--dzo-fs', '100px');
    const widths = ws.map((w) => w.offsetWidth), max = parseFloat(sec.dataset.max) || 160;
    let fs;
    if (stacked(sec)) {
      const avail = parseFloat(getComputedStyle(ws[0].parentElement).gridTemplateColumns) || row.clientWidth;
      fs = Math.min(mob.matches ? 400 : max, (avail * 100) / Math.max(...widths));
    } else {
      const total = widths.reduce((a, b) => a + b, 0) + 40 * (ws.length - 1);
      fs = Math.min(max, (row.clientWidth * 100) / total);
    }
    row.style.setProperty('--dzo-fs', Math.max(20, Math.floor(fs * 0.98)) + 'px');
  };
  const set = (el, p) => {
    el.style.setProperty('--p', (p * 100).toFixed(1) + '%');
    el.classList.toggle('is-full', p >= 1);
  };
  const paint = () => {
    const h = innerHeight;
    secs.forEach((sec) => {
      const items = [...sec.querySelectorAll('.dzo-i')];
      if (RM) return items.forEach((i) => set(i, 1));
      if (stacked(sec)) {
        items.forEach((i) => set(i, clamp((h * 0.85 - i.getBoundingClientRect().top) / (h * 0.5))));
      } else {
        const row = sec.querySelector('.dzo-row');
        if (!row) return;
        const all = clamp((h * 0.85 - row.getBoundingClientRect().top) / (h * 0.55)) * items.length;
        items.forEach((i, k) => set(i, clamp(all - k)));
      }
    });
  };
  const scan = () => document.querySelectorAll('[data-dzo]').forEach((sec) => {
    if (seen.has(sec)) return;
    seen.add(sec);
    secs.push(sec);
    fit(sec);
  });
  const refit = () => { secs.forEach(fit); paint(); };
  let t = 0;
  addEventListener('resize', () => { clearTimeout(t); t = setTimeout(refit, 120); });
  addEventListener('scroll', paint, { passive: true });
  document.addEventListener('shopify:section:load', () => { scan(); paint(); });
  scan();
  paint();
  if (document.fonts) document.fonts.ready.then(refit);
})();
